<template>
  <div class="privacy">
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>